/**
 * Panel definitions for flex/imbalance segment
 * Add your imbalance-related panels here based on backend dataset configs
 */
export const flexImbalancePanels = [
  // First row: 1 panel full width (24 cols)
  {
    id: 'imbalance-imbalance-vs-day-ahead-prices',
    type: 'datasetChart',
    datasetId: 'tennet-dispatch-prices',
    visualizationId: 'imbalance-vs-day-ahead-prices-chart',
    gridPos: { x: 0, y: 0, w: 24, h: 12 },
  },
  // Second row: 2 panels side-by-side (12 cols each)
  {
    id: 'imbalance-settlements-forecast',
    type: 'datasetChart',
    datasetId: 'profiteia-settlement-prices-forecast',
    visualizationId: 'settlement-prices-forecast-chart',
    gridPos: { x: 0, y: 12, w: 24, h: 12 },
  },
  // Third row: Dispatch Volumnes TenneT & Europese Netfrequentie
  {
    id: 'imbalance-dispatch-volumes-tennet',
    type: 'datasetChart',
    datasetId: 'tennet-balance-delta',
    visualizationId: 'tennet-balance-delta-chart',
    gridPos: { x: 0, y: 24, w: 12, h: 12 },
  },
  {
    id: 'imbalance-european-grid-frequency',
    type: 'datasetChart',
    datasetId: 'profiteia-european-grid-frequency',
    visualizationId: 'european-grid-frequency-chart',
    gridPos: { x: 12, y: 24, w: 12, h: 12 },
  },
  // Fourth row:
  {
    id: 'imbalance-opportunities-risks-last-7d',
    type: 'datasetChart',
    datasetId: 'profiteia-imbalance-opportunities-risks',
    visualizationId: 'imbalance-opportunities-risks-imbalance-opportunities',
    gridPos: { x: 0, y: 36, w: 24, h: 16 },
  },
  // mFRR directly below aFRR.
  {
    id: 'imbalance-opportunities-risks-mfrr-last-7d',
    type: 'datasetChart',
    datasetId: 'profiteia-imbalance-opportunities-risks',
    visualizationId: 'imbalance-opportunities-risks-imbalance-opportunities-mfrr',
    gridPos: { x: 0, y: 52, w: 24, h: 16 },
  },
  // Fifth row:
  {
    id: 'tennet-imbalance-settlement-prices-daily',
    type: 'datasetChart',
    datasetId: 'tennet-imbalance-settlement-prices-daily',
    visualizationId: 'imbalance-settlement-prices-daily-chart',
    gridPos: { x: 0, y: 68, w: 24, h: 12 },
  },
  // Seventh row:
  {
    id: 'tennet-imbalance-spread-rt2',
    type: 'datasetChart',
    datasetId: 'tennet-imbalance-spread-rt2',
    visualizationId: 'imbalance-spread-rt2-chart',
    gridPos: { x: 0, y: 80, w: 12, h: 12 },
  },
  {
    id: 'tennet-imbalance-prices-rt2',
    type: 'datasetChart',
    datasetId: 'tennet-imbalance-prices-rt2',
    visualizationId: 'imbalance-prices-rt2-chart',
    gridPos: { x: 12, y: 80, w: 12, h: 12 },
  },
  // Eighth row:
  {
    id: 'tennet-imbalance-rt2',
    type: 'datasetChart',
    datasetId: 'tennet-imbalance-rt2',
    visualizationId: 'imbalance-rt2-chart',
    gridPos: { x: 0, y: 92, w: 24, h: 12 },
  },
  // Ninth row:
  {
    id: 'tennet-regulation-state',
    type: 'datasetChart',
    datasetId: 'tennet-regulation-state',
    visualizationId: 'tennet-regulation-state-chart',
    gridPos: { x: 0, y: 104, w: 24, h: 12 },
  },
];
